
import { Product } from "./types";

export const hasStockConfiguration = (product: Product | null | undefined ) => product?.lowStockWarningQuantity != null;

export const anyProductHasStockConfiguration = (products: Product[], selectedProductIds: Set<string>): boolean => {
    const prods = products.filter(p => selectedProductIds.has(p.id));
    return prods.some(hasStockConfiguration);
};
